import { helper } from '@ember/component/helper';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

/**
 * @param init - modal starts opened or closed, closed by default.
 *
 * @returns - Object with a `isOpened` property and utilities to trigger the modal
 *
 */
export class UseModal {
  @tracked isOpened = false;

  constructor(init: boolean) {
    this.isOpened = init ?? false;
  }

  @action
  open() {
    this.isOpened = true;
    return this.isOpened;
  }

  @action
  close() {
    this.isOpened = false;
    return this.isOpened;
  }

  @action
  toggle() {
    this.isOpened = !this.isOpened;
    return this.isOpened;
  }
}

export function useModal([initialValue]: [boolean]): UseModal {
  return new UseModal(initialValue);
}

export default helper(useModal);
